export default "__VITE_ASSET__GyDh3eok__"